// src/styles/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background-color: #0B0C0C; /* near-black background */
    color: #00FF41; /* neon green text */
    font-family: 'Roboto', sans-serif;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
